import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { DataService } from 'services/data.service';
import { BadWords } from 'domain-models/BadWords';
import { environment } from '../../environments/environment';

@Injectable()
export class BadWordsService extends DataService<BadWords> {
	constructor(http: Http) {
		super(environment.host + 'BadWords', http);
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/services/bad-words/bad-words.service.ts